"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var variables_1 = require("../../../../../style/variables");
var styles = {
    button: react_1.css({
        width: 36,
        height: 36,
        borderRadius: 18,
        padding: 8,
        margin: 0,
        border: 'none',
        outline: 'none',
        background: "var(" + variables_1.RootColor.White + ")",
        color: "var(" + variables_1.TextColor.DEFAULT + ")",
        ':hover': {
            cursor: 'pointer',
            background: "var(" + variables_1.RootColor.Gray.LIGHT_4 + ")",
        },
        ':focus-visible, :active': {
            background: "var(" + variables_1.RootColor.Gray.LIGHT_4 + ")",
            color: "var(" + variables_1.TextColor.HEAD + ")",
        },
        ':disabled': {
            background: "var(" + variables_1.RootColor.White + ")",
            color: "var(" + variables_1.TextColor.DISABLED + ")",
            cursor: 'not-allowed',
        },
    }),
};
var TopBarIconButton = function (_a) {
    var Icon = _a.icon, buttonProps = __rest(_a, ["icon"]);
    return (react_1.jsx("button", __assign({ css: styles.button, "data-6si-name": "top-bar--icon-button" }, buttonProps),
        react_1.jsx(Icon, { size: 20 })));
};
TopBarIconButton.displayName = 'TopBar.IconButton';
exports.default = TopBarIconButton;
